console.log('✅ force-cart-drawer.js cargado');

document.addEventListener('DOMContentLoaded', function () {
  console.log('✅ DOM listo');

  const popdown = document.querySelector('[data-product-add-popdown-wrapper]');
  if (popdown) {
    popdown.remove();
    console.log('⛔ Popdown eliminado');
  }

  const buttons = document.querySelectorAll('[data-add-to-cart]');
  console.log('🧪 Botones detectados:', buttons.length);

  buttons.forEach(function(button) {
    button.addEventListener('click', function (event) {
      const form = button.closest('form[action="/cart/add"]');
      if (!form) {
        console.warn('❌ No se encontró el formulario asociado');
        return;
      }

      event.preventDefault(); // Evita envío normal

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => res.json())
        .then(() => {
          console.log('✅ Producto añadido por AJAX');

          setTimeout(function () {
            const trigger = document.querySelector('[data-drawer-toggle="drawer-cart"]');
            if (trigger) {
              console.log('🟢 Abriendo drawer del carrito');
              trigger.click();
            } else {
              console.warn('❌ No se encontró el botón de drawer');
            }
          }, 300);
        })
        .catch((err) => {
          console.error('❌ Error al añadir al carrito:', err);
        });
    });
  });
});
